import React, { Component } from "react";

import { Dropdown, Icon } from "semantic-ui-react";
import { jobassign } from "../../../actions/job-assign";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
class RemoveJob extends Component {
  /*  handleChange = (e) => {
      var hours = Number(e.target.value);
      this.props.timeupdate(this.props.date, hours, this.props.job);
  }*/
  genJob() {
    return this.props.jobs.map(job => {
      if (job.active) {
        return (
          <Dropdown.Item
            text={job.derivative + "-" + job.description}
            onClick={() => this.handleClick(job.derivative, job.description)}
          />
        );
      }
    });
  }
  handleClick = (derivative, description) => {
    console.log("Dropdown clicked");
    this.props.jobassign(derivative, false);
  };
  testclick = e => {
    console.log("Dropdown clicked " + e.target.derivative);
  };
  render() {
    return (
      <div className="RemoveJob">
        <Dropdown icon="minus square outline" button className="icon" upward>
          <Dropdown.Menu>{this.genJob()}</Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    jobs: state.jobs
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ jobassign: jobassign }, dispatch);
}
export default connect(mapStateToProps, matchDispatchToProps)(RemoveJob);



// WEBPACK FOOTER //
// ./src/components/shared-components/timesheet/removejob.js